import { Link } from "react-router-dom";

import useFetch from "../../hooks/useFetch";
import Spinner from "../../components/Spinner";

import Skeleton from '@mui/material/Skeleton';


const TransactionNotarialBookCard = () => {

  const keyToClass = {

    "RELEASED": {
      colorClass: "success",
      iconClass: "fas fa-check-circle",
    },

    "PENDING": {
      colorClass: "danger",
      iconClass: "fas fa-times-circle",
    },
  };



  const {
    data: counter_per_certificate,
    isLoading,
    errorMessage,
  } = useFetch(`${process.env.REACT_APP_API_URL}/acknowledgement_counter/`, true, {
    cacheTime: 3 * 60 * 1000, // 3 minutes
    storage: localStorage,     // or sessionStorage
  });


  return (
    <>
        {/* {isLoading && 
          <Skeleton  animation="wave" sx={{ bgcolor: 'grey.200', marginLeft:3 }} variant="rounded" width={250} height={250} />
        } */}

      {isLoading && (
        <>
          {Object.keys(keyToClass).map((key, index) => (
            <div key={index} className="mb-4 col-md" >
              <div className="card p-3  shadow-md">
                <div className="card-header d-flex justify-content-between align-items-center pb-3 ">
                  <Skeleton animation="wave" variant="text" width="40%" height={25} sx={{ bgcolor: 'grey.200' }}  />
                  <Skeleton animation="wave" variant="text" width="20%" height={25} sx={{ bgcolor: 'grey.200' }}  />
                </div>
                <div className="card-body text-center pb-0 ">
                  <Skeleton animation="wave" variant="circular" width={50} height={50} sx={{ margin: "0 auto 1rem", bgcolor: 'grey.200' }} />
                  <Skeleton animation="wave" variant="text" width="30%" height={25} sx={{ margin: "0 auto 1rem", bgcolor: 'grey.200' }} />
                </div>
              </div>
            </div>
          ))}
        </>
      )}


        {errorMessage && <div>{errorMessage}</div>}

        {counter_per_certificate &&
          Object.keys(counter_per_certificate).map((key) => (
            <div key={key} className="col-lg col-sm mb-4">
              <div className="card">
                <div className="card-header d-flex align-items-center justify-content-between">
                  <h6 className="card-title m-0 me-2">{key}</h6>
                  <div className="dropdown">
                    <button className="btn btn-sm p-0" type="button" id="totalSalesList" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >
                      Today <i className="bx bx-chevron-down" />
                    </button>
                    <div className="dropdown-menu dropdown-menu-end" aria-labelledby="totalSalesList" >
                      <Link className="dropdown-item">Yesterday</Link>
                      <Link className="dropdown-item">Last Week</Link>
                      <Link className="dropdown-item">Last Month</Link>
                    </div>
                  </div>
                </div>
                <div className="card-body text-center">
                  <div className={`avatar avatar-md border-5 border-light-${keyToClass[key].colorClass} rounded-circle mx-auto mb-4`} >
                    <span className={`avatar-initial rounded-circle bg-label-${keyToClass[key].colorClass}`} >
                      <i className="bx bx-trending-up bx-sm" />
                    </span>
                  </div>
                  <h3 className="card-title mb-1 me-2">
                    {counter_per_certificate[key]}
                  </h3>
                </div>
              </div>
            </div>
          ))}
    </>
  );
};

export default TransactionNotarialBookCard;
